<template>
  <div style="background-color: white">
    <a-layout id="">

      <a-breadcrumb style="padding: 16px 24px">
        <a-breadcrumb-item>
          <router-link :to="{name:'scf'}">
            <a-icon type="home"/>
            <span>首页</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <span>个人中心</span>
        </a-breadcrumb-item>
      </a-breadcrumb>

      <a-layout-content>
        <a-layout>
          <a-layout-sider
            width="120"
            breakpoint="lg"
            collapsed-width="0"
            theme="light"
            height="100%"
          >
            <a-menu theme="light" mode="inline"
                    v-model="selectedKeys">
              <a-menu-item key="0">
                <span class="nav-text">基本信息</span>
              </a-menu-item>
              <a-menu-item key="1">
                <span class="nav-text">修改密码</span>
              </a-menu-item>
            </a-menu>
          </a-layout-sider>
          <a-layout-content style="background-color: white">
            <a-row>
              <!--info modify-->
              <a-col
                :span="24"
                :xxl="{span:12}"
                :xl="{span:12}"
                :lg="{span:12}"
                :md="{span:16}"
                style="padding:2rem"
                v-if="selectedKeys[0]==='0' && modify">

                <h3 style="text-align: center">修改团体信息</h3>
                <a-divider></a-divider>
                <a-form-model
                  ref="ruleForm"
                  :model="form"
                  :rules="rules"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                >
                  <a-form-model-item ref="name" label="团体名称" prop="name">
                    <a-input
                      v-model="form.name"
                      @blur="() => {$refs.name.onFieldBlur();}"/>
                    <span class="text-danger" v-if="error.name">{{ error.name }}</span>
                  </a-form-model-item>
                  <a-form-model-item label="组织机构代码" required prop="USCC">
                    <a-input
                      v-model="form.USCC"
                      @blur="() => {$refs.USCC.onFieldBlur();}"/>
                    <span class="text-danger" v-if="error.USCC">{{ error.USCC }}</span>
                  </a-form-model-item>

                  <a-form-model-item label="营业执照" required prop="businessLicense">

                    <img style="height:3rem" src="" :src="form.businessLicense" @click.stop="uploadLicence">
                    <a-button style="margin-left: 1rem" type="primary" @click.stop="uploadLicence">选择文件</a-button>
                    <a-input id="licence"
                             accept="image/*"
                             type="file"
                             @change="handleLicence"
                             style="display:none"
                    />

                    <span class="text-danger" v-if="error.businessLicense">{{ error.businessLicense }}</span>
                  </a-form-model-item>

                  <a-form-model-item ref="legalName" label="法人代表姓名" prop="legalName">
                    <a-input
                      placeholder="法人代表姓名"
                      v-model="form.legalName"
                      @blur="() => {$refs.legalName.onFieldBlur();}"/>
                    <span class="text-danger" v-if="error.legalName">{{ error.legalName }}</span>
                  </a-form-model-item>

                  <a-form-model-item ref="legalPhone" label="法人代表手机号" prop="legalPhone">
                    <a-input
                      placeholder="法人代表手机号"
                      v-model="form.legalPhone"
                      @blur="() => {$refs.legalPhone.onFieldBlur();}"
                    />
                    <span class="text-danger" v-if="error.legalPhone">{{ error.legalPhone }}</span>

                  </a-form-model-item>
                  <a-form-model-item label="团体邮箱">
                    <a-input v-model="form.email"/>
                    <span class="text-danger" v-if="error.email">{{ error.email }}</span>
                  </a-form-model-item>
                  <a-form-model-item label="团体类型">
                    <a-select v-model="form.enterpriseType">
                      <template v-for="item in enterprises">
                        <a-select-option :value="item.value" :key="item.value">
                          {{ item.text }}
                        </a-select-option>
                      </template>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item label="业务范围">
                    <a-input v-model="form.business"/>
                  </a-form-model-item>


                  <a-form-model-item ref="linkman" label="联系人姓名" prop="linkman">
                    <a-input
                      v-model="form.linkman"
                      @blur="() => {$refs.linkman.onFieldBlur();}"
                    />
                    <span class="text-danger" v-if="error.linkman">{{ error.linkman }}</span>
                  </a-form-model-item>

                  <a-form-model-item ref="linkphone" label="联系人手机号" prop="linkphone" help="该手机号用于登录系统，修改成功后您将退出系统，需要重新登录。">
                    <a-input
                      v-model="form.linkphone"
                      @blur="() => {$refs.linkphone.onFieldBlur();}"/>
                    <span class="text-danger" v-if="error.linkphone">{{ error.linkphone }}</span>
                  </a-form-model-item>
                  <a-form-model-item ref="linkposition" label="联系人职位" prop="linkposition">
                    <a-input v-model="form.linkposition"/>
                  </a-form-model-item>


                  <a-form-model-item label="座机">

                    <a-input-group compact>
                      <a-input style="width: 30%" v-model="form.areacode"/>
                      <a-input style="width: 70%" v-model="form.telephone"/>
                    </a-input-group>
                  </a-form-model-item>


                  <a-form-model-item label="地址">
                    <a-input v-model="form.address"/>
                  </a-form-model-item>

                  <a-form-model-item label="邮编">
                    <a-input v-model="form.postcode"/>
                  </a-form-model-item>

                  <a-form-model-item label="职务">
                    <a-input v-model="form.mass" disabled />
                  </a-form-model-item>

                  <a-form-model-item label="当选日期" required prop="electime">
                    <a-date-picker
                      v-model="form.electime"
                      @change="error.electime=''"
                      type="date"
                      placeholder="选择一个日期"
                      valueFormat="YYYY-MM-DD"
                      style="width: 100%;"
                      disabled
                    />
                  </a-form-model-item>

                  <a-form-model-item label="证书编号">
                    <a-input v-model="form.num"/>
                  </a-form-model-item>

                  <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
                    <a-button type="primary" @click="toUpdateUser">
                      修改保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="modify=!modify">
                      取消
                    </a-button>
                  </a-form-model-item>

                </a-form-model>
              </a-col>
              <!--render info avatar-->
              <a-col v-else-if="selectedKeys[0]==='0'" style="padding: 2rem">
                <div>
                  <img class="custom-avatar" src="" alt="头像" :src="avatarUrl || defaultAvatar"
                       @click.stop="uploadHeadImg">
                  <a-button style="margin-left: 1rem" type="primary" size="small" @click.stop="uploadHeadImg">修改头像
                  </a-button>
                  <input id="newAvatar" name="photo" accept="image/*" type="file" @change="handleFile"
                         style="display:none">
                </div>
                <a-divider></a-divider>
                <a-descriptions title="基本信息" layout="vertical">
                  <a-descriptions-item label="团体名称">
                    {{ renderInfo.name || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="会员编号">
                    {{ renderInfo.membershipId || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="组织机构编码">
                    {{ renderInfo.USCC || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="法人代表姓名">
                    {{ renderInfo.legalName || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="法人代表手机号">
                    {{ renderInfo.legalPhone || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="团体邮箱">
                    {{ renderInfo.email || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="联系人姓名">
                    {{ renderInfo.linkman || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="联系人手机号">
                    {{ renderInfo.linkphone || '-' }}
                  </a-descriptions-item>


                  <a-descriptions-item label="团体类型">
                    {{ renderInfo.enterpriseType || '-' }}
                  </a-descriptions-item>


                  <a-descriptions-item label="座机">
                    {{ renderInfo.areacode }}-{{ renderInfo.telephone }}
                  </a-descriptions-item>

                  <a-descriptions-item label="地址">
                    {{ renderInfo.address || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="邮政编码">
                    {{ renderInfo.postcode || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="营业执照副本">
                    <img style="width:3rem; height:3rem" :src="renderInfo.businessLicense" alt="">
                  </a-descriptions-item>
                  <a-descriptions-item label="业务范围">
                    {{ renderInfo.business || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="简介">
                    {{ renderInfo.desc || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="职务">
                    {{ renderInfo.mass || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="当选日期">
                    {{ renderInfo.electime || '-' }}
                  </a-descriptions-item>
                  <a-descriptions-item label="证书编号">
                    {{ renderInfo.num || '-' }}
                  </a-descriptions-item>
                </a-descriptions>
                <a-button type="primary" @click="modify=!modify">修改团体信息</a-button>
                <div style="margin-top: 20px;">
                  <h4 style="margin-bottom: 10px;">会员证书</h4>
                  <div v-if="renderInfo.certificate">
                    <img
                      :key="certificateKey"
                      :src="getCertificateUrl(renderInfo.certificate)"
                      style="max-width: 400px; width: 100%; border: 1px solid #e8e8e8; border-radius: 8px; padding: 4px;"
                      alt="会员证书"
                    /><br>
                    <a-button type="primary" @click="downloadFile(renderInfo.name + '.jpg')">下载图片</a-button>
                    <a-button type="primary" @click="downloadFile(renderInfo.name + '.pdf')">下载pdf</a-button>
                  </div>
                  <div v-else style="color: #999; padding: 20px 0;">
                    暂无证书
                  </div>
                </div>
              </a-col>
              <!--password modify-->
              <a-col
                :span="24"
                :xxl="{span:16}"
                :xl="{span:16}"
                :lg="{span:16}"
                :md="{span:24}"
                style="padding:2rem"
                v-if="selectedKeys[0]==='1'">

                <a-form-model ref="passForm"
                              :model="passForm"
                              :rules="rules"
                              :label-col="labelCol"
                              :wrapper-col="wrapperCol">
                  <a-card>
                    <h3 style="text-align: center">修改密码</h3>
                    <a-divider></a-divider>
                    <a-form-model-item ref="password" label="新密码" autocomplete="off" prop="password">
                      <a-input-password v-model="passForm.password" placeholder="请输入密码"/>
                    </a-form-model-item>
                    <a-form-model-item ref="password2" label="重复密码" autocomplete="off" prop="password2">
                      <a-input-password v-model="passForm.password2" placeholder="请再次输入密码"/>
                      <span class="text-danger" v-if="passwordErr">{{ passwordErr }}</span>
                    </a-form-model-item>
                    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
                      <a-button type="primary" @click="toUpdatePass">
                        修改保存
                      </a-button>
                      <a-button style="margin-left: 10px;" @click="resetForm">
                        取消
                      </a-button>
                    </a-form-model-item>
                  </a-card>
                </a-form-model>
              </a-col>
            </a-row>


          </a-layout-content>
        </a-layout>
      </a-layout-content>

    </a-layout>
  </div>
</template>

<script>
import {getUserOrganization, updateUserOrganization} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";
import cookie from "../../../static/js/cookie";
import message from 'ant-design-vue/lib/message';
import axios from 'axios';

export default {
  name: "OrgCenter",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'));
      } else {
        if (this.passForm.password !== '') {
          callback();
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passForm.password) {
        callback(new Error("两次输入的密码不相同!"));
      } else {
        callback();
      }
    };
    return {
      userInfo: this.$store.getters.userInfo,
      defaultAvatar: '/scff/static/imgs/avatar.png',
      enterprises: [
        {'value': '1', 'text': '私营企业'},
        {'value': '2', 'text': '国有企业'},
        {'value': '3', 'text': '事业单位'},
        {'value': '4', 'text': '国有控股企业'},
        {'value': '5', 'text': '国家行政机关'},
        {'value': '6', 'text': '个体工商户'},
        {'value': '7', 'text': '合伙企业'},
        {'value': '8', 'text': '联营企业'},
        {'value': '9', 'text': '股份制企业'},
        {'value': '10', 'text': '外资企业'},
        {'value': '11', 'text': '合资企业'},
        {'value': '12', 'text': '其它'},
      ],

      renderInfo: {
        membershipId: '',
        name: '',
        USCC: '',
        linkman: '',
        linkphone: '',
        linkposition: '',
        legalName: '',
        legalPhone: '',
        enterpriseType: '',
        areacode: '',
        telephone: '',
        email: '',
        address: '',
        postcode: '',
        business: '',
        businessLicense: '',
        desc: '',
        mass: "",
        electime: "",
        certificate: "",
        num: "",
      },
      passwordErr: '',
      labelCol: {span: 6},
      modify: false,
      wrapperCol: {span: 14},
      selectedKeys: ['0'],
      avatar: '',
      avatarUrl: '',
      businessLicense: '',
      certificateKey: Date.now(),
      error: {
        membershipId: '',
        name: '',
        USCC: '',
        linkman: '',
        linkphone: '',
        legalName: '',
        legalPhone: '',
        enterpriseType: '',
        areacode: '',
        telephone: '',
        email: '',
        businessLicense: '',
      },
      form: {
        membershipId: '',
        name: '',
        USCC: '',
        linkman: '',
        linkphone: '',
        linkposition: '',
        legalName: '',
        legalPhone: '',
        enterpriseType: '',
        areacode: '',
        telephone: '',
        email: '',
        address: '',
        postcode: '',
        business: '',
        businessLicense: '',
        desc: '',
        mass: '',
        electime: '',
        num: ''
      },
      passForm: {
        password: '',
        password2: ''
      },
      rules: {
        name: [
          {required: true, message: '团体名称不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '团体名称位2-20个字符', trigger: 'blur'},
        ],
        businessLicense: [
          {required: true, message: '必须上传营业执照副本', trigger: 'blur'},
        ],
        USCC: [
          {required: true, message: '组织机构代码不能为空', trigger: 'blur'},
        ],
        linkman: [
          {required: true, message: '联系人姓名不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '联系人姓名长度不对', trigger: 'blur'},
        ],
        linkphone: [
          {required: true, message: '联系人手机号不能为空', trigger: 'blur'},
          {min: 11, max: 11, message: '手机号不正确', trigger: 'blur'},
        ],
        legalPhone: [
          {min: 11, max: 11, message: '手机号不正确', trigger: 'blur'},
        ],
        legalName: [{required: true, message: '法人代表姓名不能为空', trigger: 'blur'}],
        address: [
          {required: true, message: '地址不能为空', trigger: 'blur'},
          {min: 2, message: '地址长度不对', trigger: 'blur'},
        ],
        password: [{validator: validatePass, trigger: 'change'}],
        password2: [{validator: validatePass2, trigger: 'change'}],
      }
    }
  },
  computed: {
    params() {
      let data = new FormData()

      data.append('name', this.form.name || '')
      data.append('USCC', this.form.USCC || '')
      if (this.businessLicense) {
        data.append('business_license', this.businessLicense)
      }
      data.append('legal_name', this.form.legalName || '')
      data.append('legal_phone', this.form.legalPhone || '')
      data.append('enterprise_type', this.form.enterpriseType || '')
      data.append('business', this.form.business || '')
      data.append('linkman', this.form.linkman || '')
      data.append('linkphone', this.form.linkphone || '')
      data.append('linkposition', this.form.linkposition || '')
      data.append('address', this.form.address || '')
      data.append('postcode', this.form.postcode || '')
      data.append('areacode', this.form.areacode || '')
      data.append('telephone', this.form.telephone || '')
      data.append('email', this.form.email || '')
      data.append('desc', this.form.desc || '')
      data.append('mass', this.form.mass || '')
      data.append('num', this.form.num || '')

      if (this.form.electime) {
        if (this.form.electime.length === 10) {
          data.append('electime', this.form.electime + 'T00:00:00')
        } else {
          data.append('electime', this.form.electime)
        }
      } else {
        data.append('electime', '')
      }

      return data
    }
  },
  methods: {
    getCertificateUrl(url) {
      if (!url) return '';
      const separator = url.includes('?') ? '&' : '?';
      return url + separator + 't=' + this.certificateKey;
    },

    getAuthToken() {
      return cookie.getCookie('token') || '';
    },

    async downloadFile(fileName) {
      try {
        const token = this.getAuthToken();

        const response = await axios({
          method: 'get',
          url: '/download/',
          params: {file_name: fileName},
          responseType: 'blob',
          headers: token ? {'Authorization': `Token ${token}`} : {}
        });

        const blob = new Blob([response.data]);
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);

        message.success('下载成功');
      } catch (error) {
        console.error('下载失败:', error);
        if (error.response && error.response.status === 401) {
          message.error('请先登录');
        } else if (error.response && error.response.status === 403) {
          message.error('无权限下载该文件');
        } else if (error.response && error.response.status === 404) {
          message.error('文件不存在');
        } else {
          message.error('下载失败，请重试');
        }
      }
    },

    toUpdateUser() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          var that = this;
          // ✅ 使用 uid（User 表的 ID）
          var userId = this.userInfo.uid || cookie.getCookie('uid');

          updateUserOrganization(userId, that.params).then(res => {
            if (this.renderInfo.linkphone !== res.data.linkphone) {
              alert('信息修改成功， 请重新登录')
              cookie.delCookie('token')
              cookie.delCookie('name')
              cookie.delCookie('uid')
              cookie.delCookie('mid')
              cookie.delCookie('part')
              cookie.delCookie('id')

              this.$store.dispatch('setInfo');
              this.$store.dispatch('setPerson');
              this.$store.dispatch('setOrg');
              this.$store.dispatch('setUrl', '')

              this.$router.push({name: 'scf'})
            } else {
              alert('信息修改成功')
              this.modify = false
              this.renderInfo = filterUnderLine(res.data)
              this.certificateKey = Date.now()
            }
          }).catch(error => {
            console.log(error)
            if ("name" in error) {
              that.error.name = error.name[0];
            }
            if ("USCC" in error) {
              that.error.USCC = error.USCC[0];
            }
            if ("business_licence" in error) {
              that.error.businessLicense = error.business_licence[0];
            }
            if ("legal_name" in error) {
              that.error.legalName = error.legal_name[0];
            }
            if ("linkman" in error) {
              that.error.linkman = error.linkman[0];
            }
            if ("email" in error) {
              that.error.email = error.email[0];
            }
            if ("linkphone" in error) {
              that.error.linkphone = error.linkphone[0];
            }
          })
        }
      })
    },

    toUpdatePass() {
      this.$refs.passForm.validate(valid => {
        if (valid) {
          let params = {
            password: this.passForm.password,
            password2: this.passForm.password2
          }
          // ✅ 使用 uid（User 表的 ID）
          var userId = this.userInfo.uid || cookie.getCookie('uid');

          updateUserOrganization(userId, params).then(res => {
            alert('密码修改成功，请重新登录')
            cookie.delCookie('token')
            cookie.delCookie('name')
            cookie.delCookie('uid')
            cookie.delCookie('mid')
            cookie.delCookie('part')
            cookie.delCookie('id')

            this.$store.dispatch('setInfo');
            this.$store.dispatch('setPerson');
            this.$store.dispatch('setOrg');
            this.$store.dispatch('setUrl', '')

            this.$router.push({name: 'scf'})
          }).catch(err => {
            if ("password" in err) {
              this.passwordErr = err.password[0];
            }
            console.log(err)
          })
        } else {
          console.log('修改密码失败!!');
          return false;
        }
      });
    },

    resetForm() {
      this.$refs.ruleForm.resetFields();
    },

    uploadHeadImg: function () {
      document.getElementById("newAvatar").click()
    },

    handleFile: function (e) {
      let $target = e.target
      let file = $target.files[0]
      this.avatar = file
      let reader = new FileReader()
      reader.onload = (data) => {
        let res = data.target
        this.avatarUrl = res.result
      }
      let data = new FormData()
      data.append('avatar', this.avatar)

      // ✅ 使用 uid（User 表的 ID）
      var userId = this.userInfo.uid || cookie.getCookie('uid');

      updateUserOrganization(userId, data).then(res => {
        alert('头像修改成功')
        reader.readAsDataURL(file)
      }).catch(err => {
        console.log(err)
      })
    },

    uploadLicence: function () {
      document.getElementById("licence").click()
      document.getElementById("licence").parentElement.setAttribute('required', false)
    },

    handleLicence: function (e) {
      let $target = e.target
      let file = $target.files[0]
      this.businessLicense = file
      let reader = new FileReader()
      reader.onload = (data) => {
        let res = data.target
        this.form.businessLicense = res.result
      }
      reader.readAsDataURL(file)
    },
  },
  mounted() {
    console.log('=== OrgCenter mounted 开始 ===');
    console.log('this.userInfo:', this.userInfo);

    // ✅ 1. 直接获取 uid（User 表的 ID）
    const uid = cookie.getCookie('uid') || this.userInfo.uid || cookie.getCookie('user_id');
    console.log('获取到的 uid:', uid);

    if (!uid) {
      console.warn('❌ 未找到用户ID，请重新登录');
      this.$message.warning('请重新登录');
      this.$router.push({name: 'login'});
      return;
    }

    // ✅ 2. 直接使用 uid 请求（不用 getUserId）
    console.log('📡 开始请求 getUserOrganization, uid:', uid);

    getUserOrganization(uid)
      .then(res => {
        console.log('✅ 请求成功，原始数据:', res.data);

        // 3. 转换数据
        let arr = filterUnderLine(res.data);
        console.log('✅ 转换后的数据:', arr);

        // 4. 检查数据是否有效
        if (!arr || Object.keys(arr).length === 0) {
          console.warn('⚠️ 返回的数据为空');
          this.$message.warning('未获取到组织信息');
          return;
        }

        // 5. 渲染数据（不使用可选链）
        // ✅ 修改这里：使用 && 代替 ?.
        this.renderInfo.membershipId = (arr.user && arr.user.membershipId) || arr.membershipId || '';
        this.avatarUrl = arr.avatar || this.defaultAvatar;
        this.renderInfo.name = arr.name || '';
        this.renderInfo.USCC = arr.USCC || '';
        this.renderInfo.linkman = arr.linkman || '';
        this.renderInfo.linkphone = arr.linkphone || '';
        this.renderInfo.linkposition = arr.linkposition || '';
        this.renderInfo.legalName = arr.legalName || '';
        this.renderInfo.legalPhone = arr.legalPhone || '';
        this.renderInfo.enterpriseType = arr.typeName || arr.enterpriseType || '';
        this.renderInfo.areacode = arr.areacode || '';
        this.renderInfo.telephone = arr.telephone || '';
        this.renderInfo.address = arr.address || '';
        this.renderInfo.email = arr.email || '';
        this.renderInfo.postcode = arr.postcode || '';
        this.renderInfo.businessLicense = arr.businessLicense || '';
        this.renderInfo.desc = arr.desc || '';
        this.renderInfo.mass = arr.mass || '';
        this.renderInfo.certificate = arr.certificate || '';
        this.renderInfo.num = arr.num || '';

        // 当选日期处理
        if (arr.electime) {
          this.renderInfo.electime = arr.electime.includes('T')
            ? arr.electime.split('T')[0]
            : arr.electime;
        } else {
          this.renderInfo.electime = '';
        }

        // 6. 更新表单
        this.form = JSON.parse(JSON.stringify(this.renderInfo));
        this.form.enterpriseType = arr.enterpriseType || '';

        // 7. 刷新证书
        this.certificateKey = Date.now();

        console.log('✅ 渲染完成，renderInfo:', this.renderInfo);
        console.log('✅ 渲染完成，form:', this.form);
      })
      .catch(err => {
        console.error('❌ 请求失败:', err);
        console.error('错误详情:', err.response && err.response.data);

        if (err.response && err.response.status === 401) {
          this.$message.error('登录已过期，请重新登录');
          this.$router.push({name: 'login'});
        } else if (err.response && err.response.status === 404) {
          this.$message.error('未找到该组织信息（user_id: ' + uid + '）');
        } else {
          this.$message.error('获取信息失败，请刷新重试');
        }
      });
  }
}
</script>

<style scoped>
.custom-avatar {
  height: 6rem;
  width: 6rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/user/OrgCenter.vue